import React, { useEffect, useState } from 'react'
import SortedCurricula from '../curricula_components/CurriculaSort'
import { ISchoolGroupingMap } from 'infrastructure/api'
import { Box } from '@mui/material'
import {
  useGetDistrictGrouping,
  useGetSchoolGrouping,
} from '../curricula_components/utility'
import { SchoolCourse } from '../../../api/school.atoms'

export function GetDistrictCurricula({
  districtId,
  onDeleted,
}: {
  districtId: number
  onDeleted?: () => void
}) {
  const getGrouping = useGetDistrictGrouping()
  const [grouping, setGrouping] = useState<ISchoolGroupingMap>({})
  const [sortedKeys, setSortedKeys] = useState<string[]>([])

  useEffect(() => {
    getGrouping(districtId).then(({ grouping, sortedKeys }) => {
      setGrouping(grouping)
      setSortedKeys(sortedKeys)
    })
  }, [getGrouping, districtId])

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} width={'100%'}>
        {sortedKeys.map((groupName) => {
          const group = grouping[groupName]
          if (!group?.length) return null
          return (
            <Box key={groupName} padding={'5px'}>
              <b>{groupName}</b>
              <SortedCurricula grouping={group} onDeleted={onDeleted} />
            </Box>
          )
        })}
      </Box>
    </>
  )
}

export function GetSchoolCurricula({
  schoolId,
  bundledCurricula,
  onDeleted,
}: {
  schoolId: string | number
  bundledCurricula: SchoolCourse[]
  onDeleted?: () => void
}) {
  const getGrouping = useGetSchoolGrouping(schoolId)
  const [grouping, setGrouping] = useState<ISchoolGroupingMap>({})
  const [sortedKeys, setSortedKeys] = useState<string[]>([])

  useEffect(() => {
    getGrouping(bundledCurricula).then(({ grouping, sortedKeys }) => {
      setGrouping(grouping)
      setSortedKeys(sortedKeys)
    })
  }, [getGrouping, bundledCurricula])

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} width={'100%'}>
        {sortedKeys.map((groupName) => {
          const group = grouping[groupName]
          if (!group?.length) return null
          return (
            <Box key={groupName} padding={'5px'}>
              <b>{groupName}</b>
              <SortedCurricula grouping={group} onDeleted={onDeleted} />
            </Box>
          )
        })}
      </Box>
    </>
  )
}
